module.exports = __webpack_public_path__ + "img/platform_responder.360a9383.png";